export default __webpack_public_path__ + "static/media/Imagen_variantes_motor.777deaa4.png";